export default __webpack_public_path__ + "static/media/2021122_FIC2022-BANNER-FOR-WEB-Click.a8fc1748.gif";